// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.uploader-example {\r\n  width: 880px;\r\n  padding: 15px;\r\n  margin: 15px 15px 20px;\r\n  font-size: 12px;\r\n  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);\r\n          box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);\n}\n.uploader-example .uploader-btn {\r\n  margin-right: 4px;\n}\n.uploader-example .uploader-list {\r\n  max-height: 440px;\r\n  overflow: auto;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\n}\r\n", ""]);
// Exports
module.exports = exports;
